import {
  Component,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
} from '@angular/core';
import { ShowItem } from '../../../services/sort.service';

@Component({
  selector: 'show-item',
  templateUrl: './show-item.component.html',
  styleUrls: ['./show-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ShowItemComponent {
  @Output() update = new EventEmitter<ShowItem[]>();
  @Output() export = new EventEmitter<'pdf' | 'xlsx'>();

  public selectedShow: ShowItem;
  public showActive = false;

  @Input() mobile = false;
  @Input() position = '';

  _showItems: ShowItem[] = [];
  @Input() set showItems(val: ShowItem[]) {
    if (val && val.length > 0) {
      this._showItems = val;
      this.findSelectedShow();
    } else {
      this._showItems = null;
    }
  }

  constructor(private hostElement: ElementRef) {}

  private findSelectedShow() {
    if (this._showItems) {
      this.selectedShow = this._showItems.find((item) => item.selected);
    }
  }

  updateSelected(showItem) {
    this._showItems.forEach((i) => {
      i.selected = i.name === showItem.name;
    });
    this.update.emit(this._showItems);

    this.selectedShow = showItem;
    this.showActive = false;
  }

  toggleShow() {
    this.showActive = !this.showActive;
  }

  @HostListener('document:click', ['$event'])
  clickedOutside($event) {
    if (
      this.showActive &&
      $event.target !== this.hostElement.nativeElement &&
      this.hostElement.nativeElement.contains($event.target) === false
    ) {
      this.showActive = false;
    }
  }

  exportToExcel() {
    this.export.emit('xlsx');
  }

  exportToPDF() {
    this.export.emit('pdf');
  }

  get canShowExport(): boolean {
    if (!this.selectedShow) {
      return false;
    }

    return this.selectedShow.name === 'ordered';
  }
}
